// The phone app's scene pictures (android/app/src/main/res/drawable/scene_*.xml), drawn
// the same way so the preview and the picture picker match the phone. They are flat
// placeholders until the real artwork arrives.

const SCENES: Record<string, [string, string][]> = {
  gate: [
    ["#EBF5F3", "M0,0h320v120h-320z"],
    ["#E2DCCF", "M0,120h320v40h-320z"],
    ["#FDFBF7", "M180,30h110v90h-110z"],
    ["#E2DCCF", "M195,45h20v18h-20zM230,45h20v18h-20zM265,45h15v18h-15zM195,78h20v18h-20zM230,78h20v18h-20zM265,78h15v18h-15z"],
    ["#4A5760", "M40,50h18v72h-18zM150,50h18v72h-18z"],
    ["#E3A02F", "M36,44h26v8h-26zM146,44h26v8h-26z"],
    ["#14232B", "M58,70h92v4h-92zM58,108h92v4h-92zM68,70h4v42h-4zM84,70h4v42h-4zM100,70h4v42h-4zM116,70h4v42h-4zM132,70h4v42h-4z"],
    ["#1F7A70", "M8,80h26v42h-26z"],
    ["#FDFBF7", "M13,88h16v12h-16z"],
  ],
  "lift-lobby": [
    ["#FDFBF7", "M0,0h320v124h-320z"],
    ["#E2DCCF", "M0,124h320v36h-320z"],
    ["#4A5760", "M60,28h80v96h-80zM180,28h80v96h-80z"],
    ["#E2DCCF", "M66,34h33v90h-33zM101,34h33v90h-33zM186,34h33v90h-33zM221,34h33v90h-33z"],
    ["#E3A02F", "M148,70h12v20h-12z"],
    ["#1F7A70", "M120,136h60c8,0 8,10 0,10h-60c-8,0 -8,-10 0,-10z"],
  ],
};

export default function Illustration({ name }: { name: string | undefined }) {
  const paths = name ? SCENES[name] : undefined;
  if (!paths) return null;
  return (
    <svg viewBox="0 0 320 160" role="img" aria-label={name}>
      {paths.map(([fill, d], i) => (
        <path key={i} fill={fill} d={d} />
      ))}
    </svg>
  );
}
